import {
  FlexAnchor,
  FlexAnchorProps,
  Icon,
  lgBumps,
  mdBumps,
  Typo,
} from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import { FunctionComponent } from 'react'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { InputConfig } from '../../../../state/configuration'
import { FormFormatter } from '../../FormFormatter'

export interface ReadOnlyInputProps extends Omit<FlexAnchorProps, 'ref' | 'onClick'> {
  t: TFunction
  item: InputConfig
  onClick: () => void
}

export const ReadOnlyInput: FunctionComponent<ReadOnlyInputProps> = ({
  t,
  item,
  onClick,
  ...props
}) => {
  const { control } = useFormContext()

  return (
    <FlexAnchor
      borderRadius={2}
      backgroundColor='surfaceDisabled'
      p={mdBumps}
      onClick={onClick}
      {...props}
    >
      <Typo fontFamily='input' color='textDisabled'>
        <Controller
          name={item.name}
          control={control}
          render={({ field: { value } }) => (
            <FormFormatter value={value} input={item} t={t} />
          )}
        />
      </Typo>
      <Icon icon='info' size='tiny' ml={lgBumps} color='textDisabled' />
    </FlexAnchor>
  )
}
